import { render, staticRenderFns } from "./PageAdmin.vue?vue&type=template&id=53134a0c&scoped=true"
import script from "./PageAdmin.vue?vue&type=script&lang=js"
export * from "./PageAdmin.vue?vue&type=script&lang=js"
import style0 from "./PageAdmin.vue?vue&type=style&index=0&id=53134a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53134a0c",
  null
  
)

export default component.exports